import React, { useRef } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { changeLayout, getUserDataSuccess, postloginUser } from "store/actions";
import { localTimeToUtc } from "common/timeConversions";
import FormInput from "component/FormControl/FormInput";
import AppButton from "component/Buttons/AppButton";
import { layoutTypes } from "constants/layout";
import { emailRegExp } from "constants/constants";

const AdminLoginForm = ({ isSuperAdmin = false, ...props }) => {
  const formikRef = useRef();
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <Formik
        innerRef={formikRef}
        enableReinitialize
        initialValues={{
          email: "",
          password: "",
          company_name: "",
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string().matches(emailRegExp, "Please enter a valid email").required("Required"),
          password: Yup.string().required("Required"),
        })}
        onSubmit={(values, { setSubmitting }) => {
          const method = props?.method ? props?.method : postloginUser;
          dispatch(
            method(
              {
                email: values.email.trim(),
                password: values.password.trim(),
                company_name: values.company_name.trim(),
                current_date_time: localTimeToUtc(),
              },
              response => {
                if (props?.onSuccess) {
                  props.onSuccess(response);
                } else {
                  if (response?.email_sent_to) {
                    localStorage.setItem(
                      "loginData",
                      JSON.stringify({
                        email: response.email_sent_to,
                        ...response,
                      })
                    );
                    setSubmitting(false);
                    props.history.push("/verification?admin=1");
                  } else {
                    const data = {
                      ...response?.data,
                      uid: response.data.user_data.staff_id,
                      username: response.data.user_data.name,
                      role: "staff",
                      email: response.data.user_data.email_addresses,
                      pro_pic: response.data.user_data.profile_picture,
                      user_token: response.data.user_data.staff_token,
                      time_zone: response.data.user_data.time_zone,
                      switch_token: response.data.switch_token,
                    };
                    dispatch(getUserDataSuccess(data));
                    localStorage.setItem("uid", JSON.stringify(data.user_token));
                    localStorage.setItem("authUser", JSON.stringify(data));
                    localStorage.setItem("timezone", JSON.stringify(response.data.user_data?.time_zone));
                    localStorage.setItem("pro_pic", JSON.stringify(response.data.user_data?.profile_picture));

                    dispatch(changeLayout(layoutTypes.HORIZONTAL));
                    setSubmitting(false);
                    if (response.data.user_data?.emp_account_status) {
                      props.history.push("/staff-view");
                    } else {
                      props.history.push("/employee-profile");
                    }
                  }
                }
              },
              () => setSubmitting(false),
              props.apiHeader
            )
          );
        }}>
        {({ isSubmitting }) => {
          return (
            <Form>
              <Row>
                {!isSuperAdmin && (
                  <Col md={12} className='mb-3'>
                    <FormInput name='company_name' label='Company' labelClass='fw-normal' inputProps={{ placeholder: "Enter company name" }} />
                  </Col>
                )}
                <Col md={12} className='mb-3'>
                  <FormInput name='email' label='Email' labelClass='fw-normal' inputProps={{ placeholder: "Enter email" }} />
                </Col>
                <Col md={12} className='mb-3'>
                  <FormInput
                    name='password'
                    label='Password'
                    withShowPassword
                    labelClass='fw-normal'
                    type='password'
                    inputProps={{ placeholder: "Enter password" }}
                  />
                </Col>
                <Col md={12} className='text-center'>
                  <AppButton type='submit' isSubmitting={isSubmitting} label={props.apiHeader ? "Verify" : "Log In"} />
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default withRouter(AdminLoginForm);
